import React from "react"
import { graphql, StaticQuery, Link } from "gatsby"
// import { AnchorLink } from "gatsby-plugin-anchor-links";

// remove react-router-dom and react-dom ??

const DLink = props => {
  // console.log(props)
  let info = getlinkInfo(props.url)

  if (info.type === "internal") {
    return (
      <Link to={props.path + getAlias(props.data, info.uri)} {...props}>
        {props.value}
      </Link>
    )
  } else {
    return <p>External link not supported here</p>
  }
}

// Issue: content type path.PID doesn't seem to match the uri from the link widget

export default props => (
  <StaticQuery
    query={graphql`
      query {
        allNodePage {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeArticle {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeCaseStudy {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeSolution {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeTechnology {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
        allNodeTechnologyChild {
          edges {
            node {
              id
              path {
                alias
                pid
              }
            }
          }
        }
      }
    `}
    render={data => <DLink data={data} {...props} />}
  />
)

const getAlias = (data, pid) => {
  let alias = pid
  for (let i in data.allNodePage.edges) {
    if (data.allNodePage.edges[i].node.path.pid.toString() === pid.toString()) {
      alias = data.allNodePage.edges[i].node.path.alias
    }
  }
  return alias
}

const getlinkInfo = uri => {
  let internal1 = uri.split("entity:node/")
  let internal2 = uri.split("internal:")

  if (internal1.length > 1) return { type: "internal", uri: internal1[1] }
  if (internal2.length > 1) return { type: "internal", uri: internal2[1] }
  if (uri.substring(0, 4) === "http") return { type: "external", uri: uri }
  return { type: "unknown", uri: uri }
}
